import * as RadixSelect from '@radix-ui/react-select';
import { ReactComponent as ArrowDown } from '../../assets/icons/arrow-down.svg';
import Field, { helpId } from './Field';

// options: pole retezcu nebo { value, label }
const optionValue = (option) => (typeof option === 'string' ? option : option.value);
const optionLabel = (option) => (typeof option === 'string' ? option : option.label);
const optionDisabled = (option) => (typeof option === 'string' ? false : Boolean(option.disabled));

export const SelectControl = ({
  id,
  options = [],
  placeholder = '',
  value,
  onChange,
  disabled = false,
  required = false,
  name,
  autoComplete,
  error = '',
  describedBy,
  className = '',
  'aria-label': ariaLabel,
}) => (
  <div className={['field__control', className].filter(Boolean).join(' ')}>
    <RadixSelect.Root
      value={value}
      onValueChange={(next) => onChange?.({ target: { value: next } })}
      disabled={disabled}
      required={required}
      name={name}
      autoComplete={autoComplete}
    >
      <RadixSelect.Trigger
        id={id}
        className="field__input field__select"
        aria-label={ariaLabel}
        aria-invalid={error ? true : undefined}
        aria-describedby={describedBy}
      >
        <RadixSelect.Value placeholder={placeholder} />
        <RadixSelect.Icon className="field__select-icon">
          <ArrowDown aria-hidden="true" />
        </RadixSelect.Icon>
      </RadixSelect.Trigger>

      <RadixSelect.Portal>
        <RadixSelect.Content className="listbox" position="popper" sideOffset={4}>
          <RadixSelect.Viewport className="listbox__viewport">
            {options.map((option) => (
              <RadixSelect.Item
                key={optionValue(option)}
                value={optionValue(option)}
                disabled={optionDisabled(option)}
                className="listbox__option"
              >
                <RadixSelect.ItemText>{optionLabel(option)}</RadixSelect.ItemText>
              </RadixSelect.Item>
            ))}
          </RadixSelect.Viewport>
        </RadixSelect.Content>
      </RadixSelect.Portal>
    </RadixSelect.Root>
  </div>
);

const Select = ({
  id,
  label,
  size = 'default',
  required = false,
  help = '',
  error = '',
  className = '',
  ...rest
}) => (
  <Field
    id={id}
    label={label}
    labelFor={id}
    size={size}
    required={required}
    help={help}
    error={error}
    className={className}
  >
    <SelectControl
      id={id}
      error={error}
      describedBy={error || help ? helpId(id) : undefined}
      required={required}
      {...rest}
    />
  </Field>
);

export default Select;
